import { createRoot } from "react-dom/client";
import App from "./app";

const stored = localStorage.getItem("theme");
if (stored === "dark" || (!stored && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
    document.documentElement.classList.add("dark");
}

const container = document.getElementById("root") as HTMLElement;

declare global {
    interface Window {
        __appRoot?: ReturnType<typeof createRoot>;
    }
}

if (!window.__appRoot) {
    window.__appRoot = createRoot(container);
    window.__appRoot.render(<App />);
}
